//import { Component } from '@angular/core';
import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './login/login.component';

import { ActionTypeGrid } from './components/system-settings/action-type-grid.component';
import { CarrierDetail } from './components/carrier/carrier-detail.component';
import { CarrierDropReasonGrid } from './components/system-settings/carrier-drop-reason-grid.component';
import { CarrierSales } from './components/carrier-sales/carrier-sales.component';
import { CarrierSalesUnverifiedLoads } from './components/carrier-sales/carrier-sales-unverified-loads.component';
import { CarrierSearchGrid } from './components/carrier-list/carrier-search-grid.component';
import { CarrierServiceGrid } from './components/system-settings/carrier-service-grid.component';
import { CarrierTenderComponent } from './components/carrier-tender/carrier-tender.component';
import { CarrierTenderListComponent } from './components/carrier-tender-list/carrier-tender-list.component';
import { CityForm } from './components/city-dropdown/city-form.component';
import { ContactUnsubscribeComponent } from './components/contact-unsubscribe/contact-unsubscribe.component';
//import { CounterComponent } from './components/counter/counter.component';
import { CrmCustomerActions } from './components/crm-customer-actions/crm-customer-actions.component';
import { CrmDashboard } from './components/crm-dashboard/crm-dashboard.component';
import { CrmFollowUps } from './components/crm-follow-ups/crm-follow-ups.component';
import { CrmHome } from './components/crm-home/crm-home.component';
//import { CrmLeads } from './components/crm-leads/crm-leads.component';
import { CrmOpportunities } from './components/crm-opportunities/crm-opportunities.component';
import { CrmProspects } from './components/crm-prospects/crm-prospects.component';
import { CrossBorderGrid } from './components/tracking-dashboard/cross-border-grid.component';
import { CustomerDetail } from './components/customer/customer-detail.component';
import { CustomerList } from './components/customer-list/customer-list.component';
import { EmployeeGrid } from './components/system-settings/employee-grid.component';
import { EmployeeGroupGrid } from './components/system-settings/employee-group-grid.component';
import { EmployeeRoleGrid } from './components/system-settings/employee-role-grid.component';
import { FuelRateGrid } from './components/system-settings/fuel-rate-grid.component';
import { IndustryGrid } from './components/system-settings/industry-grid.component';
import { ModeGrid } from './components/system-settings/mode-grid.component';
//import { NavMenuComponent } from './components/navmenu/navmenu.component';
import { OpportunityQuestionCategoryGrid } from './components/system-settings/opportunity-question-category-grid.component';
import { OrderForm } from './components/order-info/order-form.component';
import { OrderPlanned } from './components/order-planned/order-planned.component';
import { OrderTracking } from './components/order-tracking/order-tracking.component';
import { SystemSettings } from './components/system-settings/system-settings.component';
import { TestPageComponent } from './components/test-page/test-page.component';
import { TagTypeGrid } from './components/system-settings/tag-type-grid.component';
import { TenderMaintenanceForm } from './components/system-settings/tender-maintenance-form.component';
import { ThirdPartyCompanyGrid } from './components/system-settings/third-party-company-grid.component';
import { TrackingDashboard } from './components/tracking-dashboard/tracking-dashboard.component';
import { TrailerTypeGrid } from './components/system-settings/trailer-type-grid.component';

export const rootRouterConfig: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'home', component: HomeComponent, canActivate: [MsalGuard] },
    //{ path: 'code', component: LoginComponent },
    { path: 'code', redirectTo: 'login' },
    { path: 'login', component: LoginComponent },
    { path: 'carrier-detail/:carrierCode', component: CarrierDetail, canActivate: [MsalGuard] },
    { path: 'carrier-detail/:carrierCode/:opportunityID', component: CarrierDetail, canActivate: [MsalGuard] },
    { path: 'carrier-tender/:orderNumber', component: CarrierTenderComponent },
    { path: 'carrier-tender-list/:carrierCode', component: CarrierTenderListComponent },
    { path: 'contact-unsubscribe/:contactId', component: ContactUnsubscribeComponent },
    {
        path: 'crm-dashboard', component: CrmDashboard, canActivate: [MsalGuard],
        children: [
            { path: '', redirectTo: 'crm-home', pathMatch: 'full' },
            { path: 'crm-home', component: CrmHome },
            { path: 'crm-home/:repType/:employeeId', component: CrmHome },
            { path: 'crm-accounts', component: CustomerList },
            { path: 'crm-accounts/:repType/:employeeId', component: CustomerList },
            { path: 'crm-accounts/:repType/:employeeId/:filter', component: CustomerList },
            { path: 'crm-customer-actions', component: CrmCustomerActions },
            { path: 'crm-customer-actions/:repType/:employeeId', component: CrmCustomerActions },
            { path: 'crm-customer-actions/:repType/:employeeId/:filter', component: CrmCustomerActions },
            //{ path: 'crm-leads', component: CrmLeads },
            //{ path: 'crm-leads/:repType/:employeeId', component: CrmLeads },
            { path: 'crm-leads', component: CustomerList },
            { path: 'crm-leads/:repType/:employeeId', component: CustomerList },
            { path: 'crm-prospects', component: CrmProspects },
            { path: 'crm-prospects/:repType/:employeeId', component: CrmProspects },
            { path: 'crm-opportunities', component: CrmOpportunities },
            { path: 'crm-opportunities/:repType/:employeeId', component: CrmOpportunities },
            { path: 'crm-follow-ups', component: CrmFollowUps },
            { path: 'crm-follow-ups/:repType/:employeeId', component: CrmFollowUps },
            { path: 'crm-follow-ups/:repType/:employeeId/:filter', component: CrmFollowUps }
        ]
    },
    { path: 'carrier-sales', component: CarrierSales, canActivate: [MsalGuard] },
    { path: 'carrier-search-grid', component: CarrierSearchGrid, canActivate: [MsalGuard] },
    { path: 'unverified-loads', component: CarrierSalesUnverifiedLoads, canActivate: [MsalGuard] },    
    { path: 'customer-detail/:customerCode', component: CustomerDetail, canActivate: [MsalGuard] },
    { path: 'customer-detail/:customerCode/:opportunityID', component: CustomerDetail, canActivate: [MsalGuard] },
    { path: 'customer-list', component: CustomerList, canActivate: [MsalGuard] },
    { path: 'order-planned', component: OrderPlanned, canActivate: [MsalGuard] },
    { path: 'order-tracking/:encryptedQuoteOrderID', component: OrderTracking },
    { path: 'order-entry/:quoteOrderID', component: OrderForm, canActivate: [MsalGuard] },
    //{ path: 'system-settings', component: SystemSettings, canActivate: [MsalGuard] },
    {
        path: 'system-settings', component: SystemSettings, canActivate: [MsalGuard],
        children: [
            //{ path: '', redirectTo: 'crm-home', pathMatch: 'full' },
            { path: 'action-types', component: ActionTypeGrid },
            { path: 'carrier-drop-reasons', component: CarrierDropReasonGrid },
            { path: 'carrier-services', component: CarrierServiceGrid },
            { path: 'cities', component: CityForm },
            { path: 'employees', component: EmployeeGrid },
            { path: 'employee-groups', component: EmployeeGroupGrid },
            { path: 'employee-roles', component: EmployeeRoleGrid },
            { path: 'fuel-rates', component: FuelRateGrid },
            { path: 'industries', component: IndustryGrid },
            { path: 'modes', component: ModeGrid },
            { path: 'opportunity-question-categories', component: OpportunityQuestionCategoryGrid },
            { path: 'tag-types', component: TagTypeGrid },
            { path: 'tender-maintenance', component: TenderMaintenanceForm },
            { path: 'third-party-companies', component: ThirdPartyCompanyGrid },
            { path: 'trailer-types', component: TrailerTypeGrid }
            //{ path: 'crm-accounts', component: CustomerList },
            //{ path: 'crm-accounts/:repType/:employeeId', component: CustomerList },
            //{ path: 'crm-accounts/:repType/:employeeId/:filter', component: CustomerList },
        ]
    },
    { path: 'test-page', component: TestPageComponent, canActivate: [MsalGuard] },
    { path: 'tracking-dashboard', component: TrackingDashboard, canActivate: [MsalGuard] },
    { path: 'cross-border', component: CrossBorderGrid, canActivate: [MsalGuard] },
    { path: '**', redirectTo: 'home' }
];
